var map = {
	"./dice.webp": 1679,
	"./esports-bg.webp": 1680,
	"./esports-ctg.webp": 1681,
	"./im-img.webp": 1682,
	"./im-title-cn.webp": 1683,
	"./im-title-en.webp": 1684,
	"./snooker.webp": 1685,
	"./spade.webp": 1686,
	"./tfg-img.webp": 1687,
	"./tfg-title-cn.webp": 1688,
	"./tfg-title-en.webp": 1689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1678;